import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import BundledProductsByCustomVariantState from "@thos/Store/Data/ProductDetails/BundledProductsByCustomVariantState";
import { Draft } from "immer";

const initialState: BundledProductsByCustomVariantState = {
    products: [],
    productInfosByProductId: {},
    attributeInfosByProductId: {},
    isLoading: false,
};

const reducer = {
    "Custom/loadBundledProductsByCustomVariant": (
        draft: Draft<BundledProductsByCustomVariantState>,
        action: { result: BundledProductsByCustomVariantState },
    ) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteLoadProductByCustomVariant": (
        draft: Draft<BundledProductsByCustomVariantState>,
        action: {
            products: [];
            productInfosByProductId: any;
            attributeInfosByProductId: any;
            attributeTypeLabel: string;
        },
    ) => {
        draft.isLoading = false;
        draft.products = action.products;
        draft.productInfosByProductId = action.productInfosByProductId;
        draft.attributeInfosByProductId = action.attributeInfosByProductId;
        draft.attributeTypeLabel = action.attributeTypeLabel;
    },
    "Custom/DispatchCompleteChangeProductByVariantQty": (
        draft: Draft<BundledProductsByCustomVariantState>,
        action: {
            productId: string;
            qtyOrdered: number;
        },
    ) => {
        draft.isLoading = false;
        draft.productInfosByProductId![action.productId].qtyOrdered = action.qtyOrdered;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
